import { useAuth } from '@/hooks/useAuth';
import { Network } from 'lucide-react';
import { Link, Navigate, Outlet, useLocation } from 'react-router-dom';

const ALWAYS_PUBLIC = new Set(['/verify-email']);

export function PublicLayout() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Authed users hitting /sign-in or /sign-up should bounce to dashboard so the
  // post-login redirect doesn't briefly flash a public page.
  if (!isLoading && isAuthenticated && !ALWAYS_PUBLIC.has(location.pathname)) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="relative flex min-h-screen flex-col bg-muted/30">
      <header className="flex h-14 items-center px-6">
        <Link to="/" className="flex items-center gap-2 font-semibold">
          <Network className="h-5 w-5" />
          DAGsight
        </Link>
      </header>
      <main className="flex flex-1 items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>
      <footer className="flex flex-col items-center gap-1 px-6 py-4 text-center text-xs text-muted-foreground">
        <div className="flex items-center gap-3">
          <Link to="/marketing-attribution" className="hover:text-foreground">
            Marketing attribution
          </Link>
          <span aria-hidden>·</span>
          <Link to="/causal-discovery-api" className="hover:text-foreground">
            API
          </Link>
          <span aria-hidden>·</span>
          <a href="mailto:hello@dagsight.com" className="hover:text-foreground">
            Contact
          </a>
        </div>
        <span>&copy; {new Date().getFullYear()} DAGsight. All rights reserved.</span>
      </footer>
    </div>
  );
}
